var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { html } from "lit-html";
import { useEffectWithoutCleanup, useState, useValidationContext } from "GlobalShared/haunted/CustomHooks";
import { MultiStringAnswer as WebMultiStringAnswer } from "WebServices/APIs/self/models/V1/CompanyInfo/Questionnaire/Answers";
import { MultiStringAnswer as AdminMultiStringAnswer } from "AdminServices/APIs/self/models/V1/CompanyInfo/Questionnaire/Answers";
import { MultiStringValidator } from "./AnswerValidators";
export const observedAttributes = ["q11e", "questionId"];
export const useShadowDOM = false;
export const name = "ww-answer-multistring";
const DEFAULTS = {
  validation: {
    required: false
  }
};
export class MultiStringChangeEvent extends CustomEvent {
  constructor(detail) {
    super("change", { detail, bubbles: true });
  }
}
export const Component = (host) => {
  const props = {
    q11e: host.q11e,
    questionId: host.questionId,
    validation: host.validation !== void 0 ? __spreadValues(__spreadValues({}, DEFAULTS.validation), host.validation) : DEFAULTS.validation
  };
  const getMultiStringAnswer = () => {
    var _a;
    if ((_a = props.q11e) == null ? void 0 : _a.isAdmin) {
      return new AdminMultiStringAnswer({
        Value: currentVal,
        QuestionId: props.questionId
      });
    }
    return new AdminMultiStringAnswer({
      Value: currentVal,
      QuestionId: props.questionId
    });
  };
  const [currentVal, setCurrentVal] = useState(void 0);
  const [question, setQuestion] = useState(void 0);
  const validationContext = useValidationContext(new MultiStringValidator(props.validation));
  const [dispatchIfValid, setDispatchIfValid] = useState(false);
  useEffectWithoutCleanup(() => {
    if (validationContext.validationResult.isValid() && dispatchIfValid) {
      setDispatchIfValid(false);
      host.dispatchEvent(
        new MultiStringChangeEvent({
          answer: getMultiStringAnswer()
        })
      );
    }
  }, [validationContext.validationResult]);
  useEffectWithoutCleanup(() => {
    if (props.q11e) {
      setQuestion(props.q11e.getQuestion(props.questionId));
      const answer = props.q11e.getAnswer(props.questionId);
      if (answer instanceof AdminMultiStringAnswer || answer instanceof WebMultiStringAnswer) {
        setCurrentVal(answer.Value);
      }
    }
  }, [props.q11e, props.questionId]);
  useEffectWithoutCleanup(() => {
    validationContext.validate(getMultiStringAnswer());
  }, [currentVal]);
  return html`
		${props.q11e !== void 0 && question !== void 0 ? html`<dc-input
					.readonly=${props.q11e.isReadonly(props.questionId)}
					.label=${question.Label + (props.validation.required ? "*" : "")}
					.value=${currentVal}
					.tooltip=${question.Tooltip !== void 0 ? question.Tooltip : ""}
					.validationMessage=${validationContext.getValidationMessage("values")}
					@change=${(e) => {
    const values = e.detail.value.split(",").map((v) => v.trim());
    setCurrentVal(values);
    setDispatchIfValid(true);
    validationContext.validateField("values");
  }}
			  ></dc-input>` : ""}
	`;
};
